<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
                    <c-form-item type="input" label="采购单号" name="order_number"></c-form-item>
                    <c-form-item type="input" label="平台订单号" name="platform_order_number"></c-form-item>
                    <c-form-item type="hidden" label="商家ID" name="stationed_id"></c-form-item>
                    <c-form-item type="input" label="供货商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
                    <c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="收货信息" name="receiving_info" placeholder="收货人、电话、地址"></c-form-item>
                    <c-form-item type="input" label="运单号" name="logistics_number" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="datetime" label="下单时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="checkbox" label="" name="order_state" :options="orderState"></c-form-item>
				</c-form>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出采购单明细</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="采购单号"
					name="order_number"
					width="140"
				>
					<template v-slot="{data}">
						<a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/purchase_order_detail/${data.order_number}`)">{{data.order_number}}</a>
					</template>
				</c-table-column>

				<c-table-column
					label="平台订单号"
					name="platform_order_number"
					width="140"
				>
					<template v-slot="{data}">
						<a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/order_detail/${data.platform_order_number}`)">{{data.platform_order_number}}</a>
					</template>
				</c-table-column>

				<c-table-column
					label="供货商家"
					name="stationed_name"
					width="150"
				></c-table-column>

				<c-table-column
					label="订单状态"
					name="order_state"
					width="80"
				>
					<template v-slot="{data}">
                        <span v-if="data.order_state==3 && data.deliver_state=='部分发货'"><br/> (<span style="color:dodgerblue">{{data.deliver_state}}</span>)</span>
                        <span v-else>
                                {{orderStateName[data.order_state]}}
                        </span>
					</template>
				</c-table-column>

				<c-table-column
					label="下单时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="采购数量"
					name="product_count"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="采购金额"
					name="product_money"
					width="100"
				>
                    <template v-slot="{data}">
                        <span  style="color:#888888">
                            ￥{{parseFloat(data.product_money).toFixed(2)}}
                        </span>
                    </template>
				</c-table-column>

				<c-table-column
					label="发货数量"
					name="send_count"
					width="80"
				>
					<template v-slot="{data}">
                        {{data.send_count}}
					</template>
				</c-table-column>

				<c-table-column
					label="发货时间"
					name="send_dates"
					width="160"
				>
					<template v-slot="{data}">
						<span v-if="data.send_dates">
                            <p v-for="(item, i) in data.send_dates.split(',')" style="margin-right: 10px;">{{item}}</p>
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button  @click="navigateTo(`/purchase_order_detail/${data.order_number}`)">查看</c-table-button>
                        <c-button v-if="data.order_state == 3" power="b_purchase_order_receipt"  @click="receiptOrder(data)" size="m" hollow>确认收货</c-button >
					</template>
				</c-table-column>
			</c-table>
		</module>
        <stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
    import stationedSelector from "@/components/service/stationed_selector.vue";
	export default {
		name: 'm_purchase_order',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
            stationedSelector
        },

        props: {
            check_state: String,
            order_state: String,
            invoice_state: String,
            pay_state: String,
            reconciliation_state: String
        },

        data() {
			return {
                workType:23,
                searchParams:{},
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
				orderState: [
                    {name: '待发货',value: 2},
                    {name: '待收货',value: 3},
                    {name: '交易完结',value: 5}
                ],
                orderNumber:'',
                orderRemark: '' //订单买家留言
            }
		},

        computed: {
            ...mapState(['systemConfig', 'userInfo']),

            defaultSearch() {
                let param = {
                    check_state: this.check_state ? this.check_state.split(',') : [],
                    order_state: this.order_state ? this.order_state.split(',') : [],
                    invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
                    reconciliation_state: this.reconciliation_state? this.reconciliation_state.split(',') : [],
                }

                if (this.pay_state == 1) {
                    param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('order.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
        },


		methods: {
			//搜索
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/purchase/order/list',
					data
				});
                this.searchParams = data;
            },
            //选择商家响应事件
            selectStationed(data) {
                this.$refs.searchForm.set({
                    stationed_id: data[0].id,
                    company_name: data[0].company_name
                });
            },
			//确认收货
            receiptOrder(data){
                var text = '';
                if (data.product_count <= data.send_count){
                    text += '采购单【'+data.order_number+'】已经全部发货';
                }else {
                    text += '采购单【'+data.order_number+'】尚未全部发货';
                }
                text += '；是否确进行确认收货操作？';
                this.$confirm({
                    title: '采购单确认收货',
                    buttonName: '确认收货',  // 确定按钮文字
                    text: text,
                    resolve: () => {
                        this.request({
                            url: '/purchase/order/receipt',
                            data: {
                                order_number: data.order_number
                            },
                            loading: true,
                            timeout: false,
                            success: (data, message) => {
                                this.$refs.table.update();
                                this.$message({
                                    text: '确认收货成功',
                                    icon: 'success'
                                });
                            }
                        });
                    }
                });
            },

            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var order_ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    order_ids = Array.from(selectDatas, item => item.data.id);
                }
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        ids:order_ids,
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>
<style lang="stylus" scoped>	
	.order {
		&-verify {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
	
	.invoice {
		padding: 5px 10px;
		box-sizing: border-box;
		
		p {
			font-weight: bold;
			margin-bottom: 30px;
			font-size: 15px;
		}
	}
</style>